import * as R from 'ramda';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect } from 'react';
import { compose, withState, withHandlers } from 'react-recompose';
// helpers/constants
import * as G from '../../helpers';
//////////////////////////////////////////////////

const withTabsMui = compose(
  withState('activeTab', 'setActiveTab', ({ defaultActiveTab }) => R.or(defaultActiveTab, 0)),
  withHandlers({
    handleSetActiveTab: ({ setActiveTab }) => (index) => setActiveTab(index),
  }),
);

const TabsMui = (props) => {
  const {
    tabs,
    count,
    activeTab,
    tabsProps,
    tabStyles,
    tabsStyles,
    permissions,
    setActiveTab,
    handleClickTab,
    defaultActiveTab,
    notHasPermissions,
  } = props;

  useEffect(() => {
    if (G.isNilOrEmpty(defaultActiveTab)) return;

    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab]);

  const handleChangeTab = (event, newValue) => {
    G.callFunctionWithArgs(handleClickTab, newValue);

    setActiveTab(newValue);
  };

  return (
    <Tabs
      {...tabsProps}
      sx={tabsStyles}
      value={activeTab}
      onChange={handleChangeTab}
    >
      {
        tabs.map(({
          text,
          value,
          withCount,
          withError,
          clickHandler,
          permissions: tabPermissions,
          notHasPermissions: tabNotHasPermissions,

        }, i) => {
          const key = `${value}${i}`;

          const label = G.ifElse(
            R.and(R.isNotNil(count), R.or(withCount, R.equals(value, activeTab))),
            `${text} (${count})`,
            text,
          );

          const allow = G.getAccessForAmousCurrentUserByPermissions(
            R.or(tabPermissions, permissions),
            R.or(tabNotHasPermissions, notHasPermissions),
          );

          return (
            <Tab
              key={key}
              label={label}
              value={value}
              sx={{
                ...tabStyles,
                display: allow ? 'block' : 'none',
                color: withError && G.getTheme('colors.light.red'),
              }}
            />
          );
        })
      }
    </Tabs>
  );
};

const tabStyles = {
  borderRadius: 15,
  minWidth: 'unset',
  minHeight: 'unset',
  padding: '4px 10px',
  '&.Mui-selected': {
    fontWeight: 600,
    color: G.getTheme('colors.dark.mainDark'),
    backgroundColor: G.getTheme('colors.white'),
  },
};

const tabsStyles = {
  px: '5px',
  maxHeight: 36,
  minHeight: 36,
  display: 'flex',
  marginTop: 'auto',
  minWidth: 'unset',
  marginBottom: '1px',
  marginRight: '10px',
  alignItems: 'center',
  borderRadius: '10px',
  width: 'max-content',
  backgroundColor: G.getTheme('colors.offWhite'),
  '& .MuiTabs-indicator': {
    display: 'none',
  },
};

const StyledTabsMui = (props) => (
  <TabsMui
    {...props}
    tabStyles={R.mergeRight(tabStyles, props.tabStyles)}
    tabsStyles={R.mergeRight(tabsStyles, props.tabsStyles)}
  />
);

const TabsMuiEnhanced = withTabsMui(TabsMui);

export {
  TabsMui,
  withTabsMui,
  StyledTabsMui,
  TabsMuiEnhanced,
};
